// Centralized client-side mirrors of backend request limits.
// Keep these aligned with:
// - paxton_app/user_files/schemas.py
// - paxton_app/user_files/database/user_file/schemas.py
// - paxton_app/user_files/folders/routers.py + folders/schemas.py
// - paxton_app/user_files/move/schemas.py
// - paxton_app/user_files/delete/schemas.py

// POST /api/v1/user-files/init-upload
export const kUserFilesInitUploadMaxBatchSize = 100

// Constants match the validated-upload stage in the file pipeline
export const kUserFilesValidatedUploadMaxFileSizeBytes = 1024 * 1024 * 1024
export const kUserFilesValidatedUploadMaxPageCount = 2500

// GET /api/v1/user-files/batch
export const kUserFilesGetMaxFileIds = 50

// POST /api/v1/user-files/move
export const kUserFilesMoveMaxFileIds = 250
export const kUserFilesMoveMaxFolderIds = 50

// POST /api/v1/user-files/delete
export const kUserFilesDeleteSelectionMaxFileIds = 250
export const kUserFilesDeleteSelectionMaxFolderIds = 50

// GET /api/v1/user-files/folders/{folder_id}/children and /files
export const kUserFilesFolderListMaxLimit = 500

// Folder create/rename name length
export const kUserFilesFolderNameMaxLength = 255

// File rename name length
export const kUserFilesFileNameMaxLength = 255
